import { FC, ReactNode } from 'react';

import styles from './Button.module.css';

type PropsButton = {
  children: ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: () => void;
};

export const Button: FC<PropsButton> = ({ children, disabled, isLoading, type, onClick }) => {
  return (
    <button className={styles.button} disabled={disabled || isLoading} onClick={onClick} type={type}>
      {isLoading ? (
        <div className={styles.borderContainer}>
          <div className={styles.loader} />
        </div>
      ) : (
        children
      )}
    </button>
  );
};
